import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
/**
 * shadcn's class-merge helper. Every generated component in `components/ui`
 * imports it, which is why it lives at the path shadcn's registry expects
 * rather than somewhere of our choosing.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
/** Tailwind's `max-md`, read once at the moment of asking. Layout belongs in classes; this is for handlers. */
export const isMobile = () => window.matchMedia("(width < 48rem)").matches;
//# sourceMappingURL=utils.js.map